export default {
  email: [{ rule: 'required' }, { rule: 'email' }]
};
